module.exports = __webpack_public_path__ + "static/media/loginLogo.b63d89a5.svg";